export default __webpack_public_path__ + "static/media/interested-in-course-bg.d3aa1943.jpg";